import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "ConfirmationDialog",
  data: function data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: null,
      defaultOptions: {
        color: "primary",
        width: 290,
        maxWidth: "85%",
        zIndex: 2000,
        isHtmlMessage: false
      }
    };
  },
  created: function created() {
    this.options = _objectSpread({}, this.defaultOptions);
  },
  methods: {
    open: function open(title, message, options) {
      var _this = this;
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = _objectSpread(_objectSpread({}, this.defaultOptions), options);
      return new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    agree: function agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};